export default __webpack_public_path__ + "static/media/loginBg.eadd6187.svg";